<template>
	<div :class="$i18n.locale === 'hk'?'banner':'banner banner-s'">
		<div class="wrap">
			<a href="https://www.ctexcel.com.hk/" class="logo"><img src="../../static/images/logo.png"/></a>
			<div class="lang">
				<a href="javascript: void(0)" @click="changeLang('hk')" :class="$i18n.locale === 'hk'?'active': ''">繁</a>
				<span>｜</span>
				<a href="javascript: void(0)" @click="changeLang('zh')" :class="$i18n.locale === 'zh'?'active': ''">简</a>
			</div>
		</div>
	</div>
</template>
 
<script>
export default {
  name: 'banner',
  methods: {
  	changeLang (val) {
  		//console.log(this.$i18n.locale);
  		this.$i18n.locale = val
  	}
  },
  
}
</script>
<style scoped>
.banner{width: 100%;}
.lang *{color: #bebebe;font-size: 14px;}
.lang a.active{color: #0d79cd;font-weight: 700;}
.logo{position: absolute;}
@media (min-width:768px) {/*pc*/
	.banner{height: 400px;background: url(../../static/images/active-banner-pc.jpg) center no-repeat;}
	.wrap{width: 1000px;margin: 0 auto;position: relative;}
	.lang{position: absolute;right: 0;top: 20px;}
	.logo{left: 75px;top: 16px;}
	.banner-s{ background-image: url(../../static/images/active-banner-pc-s.png)}
	.steps.banner{height: 235px;background: url(../../static/images/step-banner-pc.jpg) no-repeat center;}
}
@media (max-width:768px) {/*mobile*/
	.logo{top: calc(3vw);left: calc(5.5vw);}
	.logo img{width: 120px;}
	.banner{height: calc(50vw);background: url(../../static/images/active-banner-phone.jpg) center no-repeat/100% 100%;}
	.banner-s{ background-image: url(../../static/images/active-banner-phone-s.png)}
	.lang{position: absolute;right: calc(5vw);top: calc(3vw);}
	.steps.banner{height: calc(40vw);background: url(../../static/images/step-banner-m.jpg) center no-repeat/100% 100%;}
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue